import React, { useState, useEffect } from 'react'


const printOrderData = (data) => {
  console.log("printOrderData called with data:", data);
  if (window.AndroidBridge && typeof window.AndroidBridge.printOrder === 'function') {
    window.AndroidBridge.printOrder(JSON.stringify(data));
  }
}

export default printOrderData;